import { render, staticRenderFns } from "./listado-tickets.vue?vue&type=template&id=05b443d2&"
import script from "./listado-tickets.vue?vue&type=script&lang=js&"
export * from "./listado-tickets.vue?vue&type=script&lang=js&"
import style0 from "./listado-tickets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports